export default {
    functional: true,

    props:
    {
        label:
        {
            type: String,
            default: null,
        },
    },

    render(h, { data, props })
    {
        return h(
            'div',
            {
                staticClass: data.staticClass,

                class:
                [
                    'vh-card',
                    'vh-card-body',
                    'vh-card-default',
                    'vh-padding',
                    'vh-text-center',
                ],
            },
            [
                h(
                    'h4',

                    props.label
                ),
            ]
        );
    },
};



// WEBPACK FOOTER //
// ./src/components/card/vh-card-empty.js